import React from 'react';

import { RouteInterface } from 'routes';
import GenericListRoute from 'routes/generic/list';

import { DenormalizedReference } from 'store/data';

interface Props {
  routes: RouteInterface[];
}

const List: React.FC<Props> = ({ routes }) => {
  return (
    <GenericListRoute<DenormalizedReference>
      resolver="references"
      itemName="reference"
      listItemTitle={entity => entity.name}
      listTitle="References"
      detailRoute="reference"
      detailIdParam="referenceId"
      createRoute="references:create"
      dependencies={[]}
      routes={routes}
      showListTitle={true}
    />
  );
};

export default List;
